















import { Mixins, Component, Prop } from "vue-property-decorator";
import { ICopyLinkedValuesBehavior, ICopyLinkedValueBehavior } from "../../../../../documaker/domain/format/objects";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component
export default class CopyLinkedTextBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICopyLinkedValuesBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICopyLinkedValuesBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get items(): ICopyLinkedValueBehavior[] {
    return this.readPropertyOrDefault(s => s.links, []);
  }

  set items(value: ICopyLinkedValueBehavior[]) {
    this.writePropertyWhenValid(s => s.links = value);
  }

  async showCopyLinkedTextsDialog() {
    const dialog = this.commonComponents.getDialogs().getCopyLinkedTextsDialog();
    const copyLinkedTexts = await dialog.show(this.items);
    if (!copyLinkedTexts) { return; }
    this.items = copyLinkedTexts;
  }
}
